<script setup>
import { onMounted, ref } from 'vue';
import { t } from '../i18n';

defineProps({
	isLocating: { type: Boolean, default: false },
	showReloadButton: { type: Boolean, default: false },
});

const emit = defineEmits(['ready', 'reload-list']);
const mapEl = ref(null);

onMounted(() => {
	emit('ready', mapEl.value);
});

</script>

<template>
	<div class="dealer-locator__map map-locator">
		<div class="map-locator__canvas" ref="mapEl" data-testid="map-canvas"></div>
		<div v-if="isLocating" class="map-locator__overlay">
			<svg class="map-locator__icon spin-anim" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20">
				<path fill="#fff"
					d="M8.8 0q.9 0 1 1v3a1 1 0 1 1-2 0V1q0-1 1-1m0 15q.9 0 1 1v3a1 1 0 1 1-2 0v-3q0-1 1-1m8.7-10q.3.8-.4 1.4l-2.6 1.5a1 1 0 1 1-1-1.8L16 4.6a1 1 0 0 1 1.4.4m-13 7.5q.3.8-.4 1.4l-2.6 1.5a1 1 0 1 1-1-1.8l2.6-1.5a1 1 0 0 1 1.4.4m13 2.5a1 1 0 0 1-1.4.4l-2.6-1.5a1 1 0 0 1 1-1.8l2.6 1.5q.7.6.4 1.4m-13-7.5a1 1 0 0 1-1.4.4L.5 6.4a1 1 0 1 1 1-1.8l2.6 1.5q.7.6.4 1.4" />
			</svg>
			<span class="map-locator__text">{{ t.determiningLocation }}</span>
		</div>

		<Transition name="map-locator__reload-fade">
			<button v-if="showReloadButton" type="button" class="map-locator__reload dl-btn dl-btn--primary"
				@click="emit('reload-list')">
				{{ t.reloadList }}
			</button>
		</Transition>
	</div>
</template>
